import request from '@/utils/request';
import Resource from '@/api/resource';

class MaterialFormatResource extends Resource {
  constructor() {
    super('/material');
  }

  // 新建素材规格
  createMaterialFormatApi(data) {
    return request({
      url: `${this.uri}/format`,
      method: 'post',
      data,
    });
  }

  // 删除素材规格
  removeMaterialFormatApi(id) {
    return request({
      url: `${this.uri}/format/${id}`,
      method: 'delete',
    });
  }

  // 更新素材规格
  updateMaterialFormatApi(data, id) {
    return request({
      url: `${this.uri}/format/${id}`,
      method: 'put',
      data,
    });
  }

  // 获取素材规格列表
  getMaterialFormatListApi(params) {
    return request({
      url: `${this.uri}/format`,
      method: 'get',
      params,
    });
  }
}

export { MaterialFormatResource as default };
